module.exports = __webpack_public_path__ + "static/media/izlozba (5).a27b88f4.jpg";